export const RIPNDIP_TYPE_TO_IMAGE: Record<number, string> = {
  1: "/images/ripndip/love_lemon_bomb_type_1.png",
  2: "/images/ripndip/love_gun_type_2.png",
  3: "/images/ripndip/signs_of_love_type_3.png",
  4: "/images/ripndip/the_peacemaker_tank_type_4.png",
};

export const RIPNDIP_TYPE_TO_VARIANT: Record<number, string> = {
  1: "LEMON LOVE BOMB",
  2: "LOVE GUN",
  3: "SIGNS OF LOVE",
  4: "THE PEACEMAKER TANK",
};

export const RIPNDIP_TYPE_TO_RARITY: Record<number, string> = {
  1: "Common",
  2: "Common",
  3: "Common",
  4: "Rare",
};

const RIPNDIP_FALLBACK_IMAGE = "/images/ripndip/ripndip-landing.png";

export function getRipndipImageUrl(tokenType?: number) {
  return tokenType
    ? RIPNDIP_TYPE_TO_IMAGE[tokenType] || RIPNDIP_FALLBACK_IMAGE
    : RIPNDIP_FALLBACK_IMAGE;
}

export function getRipndipVariantName(tokenType?: number) {
  return tokenType ? RIPNDIP_TYPE_TO_VARIANT[tokenType] || `Type ${tokenType}` : "223 x Ripndip x Ponke";
}

export function getRipndipTokenTypeFromVariant(
  variant?: string
): number | undefined {
  if (!variant) return undefined;

  const normalizedVariant = variant.trim().toUpperCase();
  const matchedEntry = Object.entries(RIPNDIP_TYPE_TO_VARIANT).find(
    ([, value]) => value.toUpperCase() === normalizedVariant
  );

  return matchedEntry ? Number(matchedEntry[0]) : undefined;
}

export function getRipndipImageUrlFromVariant(variant?: string): string {
  return getRipndipImageUrl(getRipndipTokenTypeFromVariant(variant));
}
